import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { 
  Home, School, Newspaper, Calendar, Code, Trophy, Image, Users, 
  Folder, Phone, Key, LogOut, Menu, X
} from 'lucide-react';
import logo from "./MMPSRPC_Logo.svg";

const navItems = [
  { name: 'Dashboard', icon: Home, path: '/' },
  { name: 'Colleges', icon: School, path: '/colleges' },
  { name: 'News', icon: Newspaper, path: '/news' },
  { name: 'Events', icon: Calendar, path: '/events' },
  { name: 'Hackathons', icon: Code, path: '/hackathons' },
  { name: 'Achievements', icon: Trophy, path: '/achievements' },
  { name: 'Gallery', icon: Image, path: '/gallery' },
  { name: 'Coordinators', icon: Users, path: '/coordinators' },
  { name: 'Projects', icon: Folder, path: '/projects' },
  { name: 'Contacts', icon: Phone, path: '/contacts' },
  { name: 'Update Password', icon: Key, path: '/update-password' },
];

const Layout = ({ children }) => {
  const location = useLocation();
  const { logout } = useAuth();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Mobile menu button */}
      <button
        className="fixed z-50 p-2 m-4 text-gray-600 bg-white rounded-full shadow-lg lg:hidden focus:outline-none focus:ring-2 focus:ring-gray-300"
        onClick={toggleSidebar}
      >
        {isSidebarOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Sidebar */}
      <aside
        className={`fixed inset-y-0 left-0 z-40 w-72 transition-all duration-300 ease-in-out transform bg-white shadow-xl lg:relative lg:translate-x-0 ${
          isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="flex flex-col h-full">
          <Link to='/'>
          <div className="flex flex-col items-center justify-center h-40 bg-gray-50">
            <img src={logo} alt="Logo" className="h-24 w-auto" />
            <span className="mt-2 text-2xl font-semibold text-gray-800">Admin</span>
          </div>
          </Link>
          <nav className="flex-grow px-4 pb-4 mt-5 overflow-y-auto">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`flex items-center px-4 py-3 mt-2 text-gray-700 transition-all duration-200 transform rounded-lg hover:bg-gray-100 ${
                  location.pathname === item.path ? 'bg-gray-200 text-indigo-600 font-semibold' : ''
                }`}
                onClick={() => setIsSidebarOpen(false)}
              >
                <item.icon className="w-5 h-5" />
                <span className="mx-4 font-medium">{item.name}</span>
              </Link>
            ))}
          </nav>
          <div className="p-4 mt-auto">
            <button
              onClick={() => {
                logout();
                setIsSidebarOpen(false);
              }}
              className="flex items-center justify-center w-full px-4 py-2 text-white bg-red-500 rounded-lg hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 transition-all duration-200 transform hover:scale-105"
            >
              <LogOut className="w-5 h-5 mr-2" />
              Logout
            </button>
          </div>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100">
        <div className="container px-6 py-8 mx-auto">
          {children}
        </div>
      </main>

      {/* Overlay for mobile */}
      {isSidebarOpen && (
        <div 
          className="fixed inset-0 z-30 bg-black bg-opacity-50 lg:hidden"
          onClick={() => setIsSidebarOpen(false)}
        ></div>
      )}
    </div>
  );
};

export default Layout;